import { render, staticRenderFns } from "./categories-videos.vue?vue&type=template&id=76ad140d&scoped=true&"
import script from "./categories-videos.vue?vue&type=script&lang=js&"
export * from "./categories-videos.vue?vue&type=script&lang=js&"
import style0 from "./categories-videos.vue?vue&type=style&index=0&id=76ad140d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ad140d",
  null
  
)

export default component.exports